import { Component, computed, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';
import { AuthService } from '@services/auth.service';
import { MenuConfigService } from '@services/menu-config.service';
import { BackendToastrService } from '@services/util/backend-toastr.service';
import { ToastWrapperService } from '@services/toast-wrapper.service';
import { ToasterComponent } from './components/toaster/toaster.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LOCAL_STORAGE } from '@services/storage.service';
import { JsonParseSafeService } from '@services/json-parse-safe.service';


// source ~/.nvm/nvm.sh
// source ~/.zshrc
@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    ToasterComponent
  ]
})
export class AppComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  public blurActive: boolean;
  private transitionTimeout: any;

  private translate = inject(TranslateService);
  public authService = inject(AuthService);
  private activatedRoute = inject(ActivatedRoute);
  private backendToastrService = inject(BackendToastrService);
  private toastWrapperService = inject(ToastWrapperService);
  public router = inject(Router);
  public localStorage = inject(LOCAL_STORAGE);
  private menuConfigService = inject(MenuConfigService);
  private jsonParseSafeService = inject(JsonParseSafeService);
  isNavigating = computed(() => !!this.router.currentNavigation());

  constructor() {
    const langConfig = this.localStorage.getItem('tktCurrentLang');
    if (!langConfig) {
      this.translate.setFallbackLang('en');
      this.translate.use('en');
    } else {

    }
    let config = this.jsonParseSafeService.safeParse(langConfig, {code: 'en'});
    const lang = config.code;
    this.translate.setFallbackLang(lang);
    this.translate.use(lang);
  }

  ngOnInit(): void {
    console.log('02.11.26')
    this.backendToastrService.cartCount$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(error => this.toastWrapperService.errorMessage(error));

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let rt = this.getChild(this.activatedRoute);
        rt.data.subscribe(data => this.menuConfigService.setData(data));
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.transitionTimeout = setTimeout(() => this.blurActive = true);
      }

      if (event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel) {
        this.blurActive = false;
        clearTimeout(this.transitionTimeout);
      }
    });

  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
